import React from "react";
import styles from "./index.module.scss";

interface FieldErrorProps {
  text: string | undefined;
  show: boolean | string | undefined;
}
export const FieldError: React.FC<FieldErrorProps> = ({ text, show }) =>
  show && (text ?? "").length > 0 ? (
    <div className={styles.error_text}>{text ?? "نامشخص"}</div>
  ) : null;
